export const SET_HOTEL = 'GUIDE/HOTEL/SET_HOTEL'
